import { z } from 'zod';

export const JobResponseTurnSchema = z.enum(['YOUR_TURN', 'THEIR_TURN']).nullable();
export const JobResponseActionSchema = z.enum(['accept', 'counter', 'withdraw', 'reject']);

type JobResponseAction = z.infer<typeof JobResponseActionSchema>;

const warnedUnknownActions = new Set<string>();

// The API deploys several minutes before the client and open tabs keep running
// the old bundle, so an action this client does not know yet must not fail the
// whole list. Keep the known actions, warn once per unknown value, never throw.
export const JobResponseAvailableActionsSchema = z
  .array(z.string())
  .default([])
  .transform((actions) =>
    actions.filter((action): action is JobResponseAction => {
      if (JobResponseActionSchema.safeParse(action).success) return true;
      if (!warnedUnknownActions.has(action)) {
        warnedUnknownActions.add(action);
        console.warn(`Ignoring unknown job response action "${action}".`);
      }
      return false;
    })
  );

export type JobResponse = {
  id: number;
  listingType: string;
  jobListingId?: number;
  msaasListingId?: number;
  providerServiceListingId?: number | null;
  respondingProviderId?: number;
  respondingEmployerId?: number;
  respondingUserInfoId: number;
  status: string;
  appliedAt?: string;
  viewedAt?: string;
  deletedFlag?: boolean;
  unmaskEligible?: boolean;
  unmaskEligibleReason?: string;
  unmaskRequestedAt?: string;
  unmaskApprovedAt?: string;
  isUnmasked: boolean;
  unmaskedAt?: string;
  initialNegotiationId?: number | null;
  latestNegotiationId?: number | null;
  negotiationCount?: number;
  messageCount?: number;
  responseProviders?: Array<{
    responseProviderId: number;
    providerId?: number;
    displayName: string;
    masked: boolean;
    providerCategory?: string | null;
    providerType?: string | null;
    verificationLevel?: number | null;
    npiNum?: string | null;
  }>;
};
